import AbstractRepository from './AbstractRepository';
import collect from 'collect.js';

interface AgedamentoPost {
    polo_id: number,
    servico_id: number,
    data_hora: string,
    nome: string,
    celular: string,
    email?: string,
    cpf: string
}

interface HorariosDisponiveisFilters { }

export default class ServicoRepository extends AbstractRepository {
    static resource = 'agendamento';

    /**
     * Cadastro um novo agendamento
     * 
     * @param dados Informações do agendamento
     */
    public static async cadastrar(dados: AgedamentoPost) {
        return await this.post(`${this.resource}`, dados)
    }

    /**
     * Resgata hirários disponíveis
     * 
     * @param filters Filtros para API
     * 
     * @return Collection<unknown>
     */
    public static async horarios_disponiveis(polo_id: number, servico_id: number, data: string, filters: HorariosDisponiveisFilters = {}) {
        let response = await this.get(`polo/${polo_id}/servico/${servico_id}/data/${data}`, filters);
        let lista = collect(response);
        let local_timezone_str = process.env.VUE_APP_TIMEZONE || '-3';
        let local_timezone = parseInt(local_timezone_str);
        lista.map((dados: any) => {
            let tm = '-';
            dados.hora_agendado = dados.timezone;
            if (dados.hora_agendado.includes('+')) tm = '+';
            let split = dados.hora_agendado.split(tm);
            let api_timezone = parseInt(`${tm}${split[1]}`);
            let split_horario = split[0].split(':');
            let hora = parseInt(split_horario[0]);
            let minuto = split_horario[1];
            // let segundo = split_horario[2];
            let timezome: number;
            if ( local_timezone < api_timezone ) timezome = local_timezone - api_timezone;
            else timezome = -(local_timezone - api_timezone);
            hora = hora + timezome;
            let horaString;
            horaString = hora.toString().padStart(2, '0');
            dados.hora_local = `${horaString}:${minuto}`;
            dados.timezone = api_timezone;
        });
        return lista;
    }

    public static async getDiasDisponiveis(polo_id:number, servico_id:number, data_inicio:string, data_fim:string):Promise<any>{
        const path = `/polo/${polo_id}/servico/${servico_id}/data_inicio/${data_inicio}/data_Fim/${data_fim}`
        return this.get(path)
    }

    public static async getUserSchedules(protocol:String,cpf:String,cellphone:String){
        return new Promise((resolve,reject) => {
            if(cellphone !== null && cpf !== null){
                this.get(`agendamento?cpf=${cpf}&telefone=${cellphone}`)
                .then(
                    (response) => {
                        resolve(response)
                    },
                    (error) => {
                        resolve(false)
                    }
                )
            }
            else if(protocol !== null && cpf !== null){
               this.get(`agendamento?cpf=${cpf}&protocolo=${protocol}`)
               .then(
                   (response) => {
                        resolve(response)
                   },
                   (error) => {
                        resolve(false)
                   }
               )
            }
            else if(protocol !== null && cellphone !== null){
                this.get(`agendamento?protocolo=${protocol}&telefone=${cellphone}`)
                .then(
                    (response) => {
                        resolve(response)
                    },
                    (error) => {
                        resolve(false)
                    }
                )
            }
        })
    }

    public static async cancelSchedule(protocol:String){
        return new Promise((resolve,reject) => {
            this.put(`agendamento/${protocol}`)
            .then(
                (response) => {
                    resolve(response.mensagem)
                },
                (error) => {
                    resolve(false)
                }
            )
        })
    }
}
